/**
 * WMO Weather interpretation codes (https://open-meteo.com/en/docs) -> Bootstrap Icon + deutsches
 * Tooltip-Label. Backend gibt den rohen Code unverändert durch (siehe OpenMeteoProvider.js) — die
 * Zuordnung zu Icon/Text ist reine Darstellungssache und lebt deshalb hier im Frontend.
 */
const WMO_ICONS = {
	0: { icon: 'bi-sun-fill', label: 'Klar' },
	1: { icon: 'bi-cloud-sun-fill', label: 'Leicht bewölkt' },
	2: { icon: 'bi-cloud-sun-fill', label: 'Teilweise bewölkt' },
	3: { icon: 'bi-cloud-fill', label: 'Bedeckt' },
	45: { icon: 'bi-cloud-fog2-fill', label: 'Nebel' },
	48: { icon: 'bi-cloud-fog2-fill', label: 'Nebel mit Reifablagerung' },
	51: { icon: 'bi-cloud-drizzle-fill', label: 'Leichter Niesel' },
	53: { icon: 'bi-cloud-drizzle-fill', label: 'Mäßiger Niesel' },
	55: { icon: 'bi-cloud-drizzle-fill', label: 'Starker Niesel' },
	56: { icon: 'bi-cloud-drizzle-fill', label: 'Leichter gefrierender Niesel' },
	57: { icon: 'bi-cloud-drizzle-fill', label: 'Starker gefrierender Niesel' },
	61: { icon: 'bi-cloud-rain-fill', label: 'Leichter Regen' },
	63: { icon: 'bi-cloud-rain-fill', label: 'Mäßiger Regen' },
	65: { icon: 'bi-cloud-rain-fill', label: 'Starker Regen' },
	66: { icon: 'bi-cloud-rain-heavy-fill', label: 'Leichter gefrierender Regen' },
	67: { icon: 'bi-cloud-rain-heavy-fill', label: 'Starker gefrierender Regen' },
	71: { icon: 'bi-cloud-snow-fill', label: 'Leichter Schneefall' },
	73: { icon: 'bi-cloud-snow-fill', label: 'Mäßiger Schneefall' },
	75: { icon: 'bi-cloud-snow-fill', label: 'Starker Schneefall' },
	77: { icon: 'bi-cloud-snow-fill', label: 'Schneegriesel' },
	80: { icon: 'bi-cloud-rain-heavy-fill', label: 'Leichte Regenschauer' },
	81: { icon: 'bi-cloud-rain-heavy-fill', label: 'Mäßige Regenschauer' },
	82: { icon: 'bi-cloud-rain-heavy-fill', label: 'Heftige Regenschauer' },
	85: { icon: 'bi-cloud-snow-fill', label: 'Leichte Schneeschauer' },
	86: { icon: 'bi-cloud-snow-fill', label: 'Starke Schneeschauer' },
	95: { icon: 'bi-cloud-lightning-fill', label: 'Gewitter' },
	96: { icon: 'bi-cloud-lightning-rain-fill', label: 'Gewitter mit leichtem Hagel' },
	99: { icon: 'bi-cloud-lightning-rain-fill', label: 'Gewitter mit starkem Hagel' },
};

const WMO_FALLBACK = { icon: 'bi-cloud', label: 'Unbekannt' };

export { WMO_ICONS, WMO_FALLBACK };
